function pickupAvailableElement(){
  const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
  if (productForm) {
      const productIdInput = productForm.querySelector('input[name="id"]');
      const product_url = document.querySelector('#product-data[data-product-url]').getAttribute('data-product-url');
      const checkType   = document.querySelector('#product-data[data-product-url]').getAttribute('data-shipping-check-type');
      let viewName = 'shipping-check-ajax';
    //   if (checkType === 'metafield') {
    //         viewName = 'shipping-check-metafield';
    //   }
      if (productIdInput) {
          const variantId = productIdInput.value;
          console.log('Product Form ID:', variantId);
          console.log('product_url:', product_url);
          const url = `${product_url}?variant=${variantId}&view=${viewName}`;
          const xhr = new XMLHttpRequest();
          xhr.open('GET', url, true);
          xhr.responseType = 'document';
          xhr.onload = function () {
    if (xhr.status >= 200 && xhr.status < 300) {
        const responseHTML = xhr.response;
        const pickupAvailableElement = responseHTML.querySelector('.pickupvailable');
        const importantNotice        = responseHTML.querySelector('.important-notice');
        const shippiAvailableElement = responseHTML.querySelector('.shipping-available');
        const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
        const badge = document.querySelector('.Pickup_alert_badge');
        // Remove previous hidden input if exists
        const pickupInput = document.getElementById('pickup_only_data');
        if (pickupInput) pickupInput.remove();
        // Clear any badge first
        if (badge) badge.textContent = "";
        // Remove pickup-only class initially
        if (document.querySelector('.product-form__buttons')?.classList.contains('pick_only_btn_class')) {
            document.querySelector('.product-form__buttons').classList.remove('pick_only_btn_class');
        }
        if (shippiAvailableElement) {
            const shippingText = shippiAvailableElement.textContent.trim();
            console.log("Shipping Available:", shippingText);
            if (badge) badge.textContent = shippingText;
            // Remove existing style classes first
             badge.classList.remove('pickup-style');
             badge.classList.add('shipping-style');
            // Optional: create a hidden input or visual display if needed
            // const shippingOnlyInput = document.createElement('input');
            // shippingOnlyInput.id = 'shipping_only_data';
            // shippingOnlyInput.type = 'hidden';
            // shippingOnlyInput.name = 'properties[Shipping Message]';
            // shippingOnlyInput.value = shippingText;
            // productForm.appendChild(shippingOnlyInput);

        } else if (pickupAvailableElement) {
            const pickupText = pickupAvailableElement.textContent.trim();
            const pickupNotice = importantNotice?.textContent.trim() || "";
            console.log("Pickup Available:", pickupText);
            console.log("Pickup Notice:", pickupNotice);
            if (badge) badge.textContent = pickupText;
           // Remove existing style classes first
            badge.classList.remove('shipping-style');
            badge.classList.add('pickup-style');
            // Add hidden input
            const pickupOnlyInput = document.createElement('input');
            pickupOnlyInput.id = 'pickup_only_data';
            pickupOnlyInput.type = 'hidden';
            pickupOnlyInput.name = 'properties[Important Note]';
            pickupOnlyInput.value = pickupText;
            productForm.appendChild(pickupOnlyInput);

            // Add class for pickup warning popup
            if (document.querySelectorAll('.product-form__buttons').length > 0) {
                document.querySelector('.product-form__buttons').classList.add('pick_only_btn_class');
            }

        } else {
            // Neither pickup nor shipping available
            console.warn("No pickup or shipping options available.");
            if (badge) badge.textContent = "";
             badge.classList.remove('pickup-style', 'shipping-style');
            // if (badge) badge.textContent = "Currently unavailable for pickup or shipping.";
        }
    } else {
        console.error('Request failed with status:', xhr.status);
    }
};
          // Send the request
          xhr.send();
      }
  }
}
pickupAvailableElement();

document.addEventListener("DOMContentLoaded", function() {
    var radioInputs = document.querySelectorAll('variant-radios input[type="radio"]');
    radioInputs.forEach(function(input) {
        input.addEventListener("click", function(event) {
          setTimeout(function() {
            pickupAvailableElement();
          }, 100);
        });
    });
});


// ========================================Start alert warning popup on add to cart/Buy Now==============================================//
document.addEventListener("DOMContentLoaded", function() {
   var pick_only_btn_div = document.querySelectorAll('.product-form__submit');
     pick_only_btn_div.forEach(function(input) {
        input.addEventListener("click", function(event) {
          setTimeout(function() {
            if (input.parentElement.classList.contains('pick_only_btn_class')) {
             // $('#myModal_shipping_check_data').modal('show');
            
            }
          }, 100);
           
        });
    });


    var shopifyPaymentButtons = document.querySelectorAll('.shopify-payment-button__button');
    shopifyPaymentButtons.forEach(function(button) {
        button.addEventListener("click", function(event) {
            let parent = button.parentElement;
            while (parent) {
                if (parent.classList.contains('pick_only_btn_class')) {
                    alert("This product is currently out of stock, but you can still pick it up at certain locations. Choose 'Pick up' at checkout, or your order won't go through.");
                    break; // Exit the loop once we've found the relevant parent
                }
                parent = parent.parentElement;
            }
        });
    });


   
});

// ==========================================End alert warning popup on add to cart/Buy Now==============================================//


// ================================================Start Triggering on popup proceed==========================================================//
document.addEventListener("DOMContentLoaded", function() {
   var shipping_check_data_add_to_cart = document.querySelectorAll('.shipping_check_data_add_to_cart');
    if(shipping_check_data_add_to_cart.length > 0){
           shipping_check_data_add_to_cart.forEach(function(input) {
          input.addEventListener("click", function(event) {
           if (document.querySelector('.product-form__buttons').classList.contains('pick_only_btn_class')) {
                document.querySelector('.product-form__buttons').classList.remove('pick_only_btn_class')
                document.querySelector('.product-form__submit').click();
              }
             
          });
      });
    }
})
// ================================================End Triggering on popup proceed==========================================================//
